import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MainLoaderService } from '@hal/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-forbidden-page',
  imports: [CommonModule, TranslateModule],
  templateUrl: './forbidden-page.component.html',
  styleUrls: ['./forbidden-page.component.scss'],
})
export class ForbiddenPageComponent {
  constructor(private _mainLoaderService: MainLoaderService) {
    this._mainLoaderService.hideLoader();
  }
}
